export default __webpack_public_path__ + "static/media/wika_konstruksi.58cf6bdd.png";